FontAwesomeConfig = { searchPseudoElements: true };

import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/brands';

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


jQuery(document).ready(function($) {
	var windowWidth = $(window).width()

	$('.purple-word-background').each(function() {
		$(this).contents().wrap('<span/>');
	});

/* ====================== MOBILE NAV ======================  */
	$('.menu-toggle').on("click", function() {
		$(this).toggleClass('active');
		$('header nav').toggleClass('open');
		$('header').toggleClass('open');
		$('body').toggleClass('noscroll');
	})

	if(windowWidth < 1024) {
		$('#menu-main-menu .menu-item-has-children').on("click", function() {
		   $(this).toggleClass('expanded');
		   $(this).find('.sub-menu').slideToggle();
		})
	}

/* ====================== Quick Form ======================  */
	$('.quick-form-trigger').on("click", function() {
		$(this).parent().toggleClass('active');
	})

	$('.quick-form-container h4').on("click", function() {
		$('.quick-form-container').removeClass('active');
	})

	$(document).on('click', function(event) {
	    var quickFormContainer = $('.quick-form-container');

	    if (!$(event.target).closest(quickFormContainer).length && $(event.target) !== quickFormContainer[0]) {
	    	$(quickFormContainer).removeClass('active');
	    }
	});

/* ====================== Semi Sticky Nav ======================  */
	var prevScrollpos = window.pageYOffset;
	var currentScrollPos = window.pageYOffset;

	if(currentScrollPos > 120) {
		$("header").addClass("headerscrolled");
	}

	window.onscroll = function() {
		var currentScrollPos = window.pageYOffset;

		if ((prevScrollpos > currentScrollPos)) {
			$('header').addClass('show');
		} else if((prevScrollpos < currentScrollPos)){
			$('header').removeClass('show');
		}
		else {
			$('header').removeClass('show');
		}

		if(currentScrollPos > 120) {
			$("header").addClass("headerscrolled");
		} else {
			$("header").removeClass("headerscrolled show");
		}

		prevScrollpos = currentScrollPos;
	}

/* ====================== Logo Carousel ======================  */
	const logoCarousel = new Swiper('.logo-carousel .carousel', {
		spaceBetween: 30,
		autoplay: {
			delay: 0,
		},
		allowTouchMove: false,
		slidesPerView: 2,
		speed: 5000,
		loop: true,
		breakpoints: {
			768: {
				spaceBetween: 20,
				slidesPerView: 3,
			},
			1024: {
				slidesPerView: 5,
				spaceBetween: 50,
			}
		}
	});

/* ====================== List Reveal ======================  */
	$('.list-reveal .list-item:first-of-type, .list-reveal .image-container:first-of-type').addClass('active');
	$('.list-reveal .list-item').on("mouseover", function () {
		var index = $(this).attr('data-related');

		$('.list-reveal .image-container, .list-reveal .list-item').removeClass('active');
		$(this).addClass('active');
        $('.list-reveal .image-container[data-related=' + index + ']').addClass('active');
    });


/* ====================== Submit Gravity Form ======================  */
	jQuery(document).on('gform_post_render', function(){
	     $('.gform_wrapper .btn').on('click', function() {
        	$(this).parents('.gform_wrapper').find('input[type=submit]').click();
        });
	});

/* ====================== Expanding Content Grid ======================  */
	$('.expanding-content-grid .grid-item:not(.flip-action)').on("click", function() {
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).find('.hidden-content').slideUp();
		} else {
			$('.expanding-content-grid .grid-item').removeClass('active');
			$('.hidden-content').slideUp();
			$(this).addClass('active');
			$(this).find('.hidden-content').slideDown();
		}
	})

/* ====================== Omnicore Diagram ======================  */
	$('.omnicore-diagram .diagram-content').on("mouseover", function() {
		$(this).addClass('active');
	})

	$('.omnicore-diagram .diagram-content').on("mouseleave", function() {
		$('.omnicore-diagram .diagram-content').removeClass('active');
	})

/* ====================== COPY URL TO CLIPBOARD ======================  */
	$('.social-share-link-url').on("click", function() {
		var dummy = document.createElement('input'),
		text = window.location.href;

		document.body.appendChild(dummy);
		dummy.value = text;
		dummy.select();
		document.execCommand('copy');
		document.body.removeChild(dummy);

		$(this).addClass('copied');

		setTimeout(
		function() {
			$('.social-share-link-url').removeClass('copied');
		}, 2000);
	});

/* ====================== GSAP Animations ======================  */
	let phone = gsap.utils.toArray('.content-with-phone')
	phone.forEach((item, index) => {
		let tl = gsap.timeline({
		scrollTrigger: {
		trigger: item,
		scrub: true,
		start:"-200 90%",
		toggleActions:"restart none none reset",
		end: "1500",
		markers: false
		}
		});
		tl.to($('.content-with-phone .phone'), {
			y: 0,
		});
	});

	let columns = gsap.utils.toArray('.scrolling-logo-columns .column')
	columns.forEach((item, index) => {
		let tl = gsap.timeline({
		scrollTrigger: {
		trigger: item,
		scrub: true,
		start:"-250 50%",
		toggleActions:"restart none none reset",
		end: "250 50%",
		markers: false,
		}
		});
		tl.to(item, {
			y: 0,
		});
	});

	let progressBar = gsap.utils.toArray('.content-with-sticky-images')
	progressBar.forEach((item, index) => {
		let tl = gsap.timeline({
		scrollTrigger: {
		trigger: item,
		scrub: true,
		start:"0 50%",
		toggleActions:"restart none none reset",
		end: "bottom 50%",
		markers: false
		}
		});
		tl.to($('.progress-bar'), {
			width: '100%',
		});
	});

	let contentBlock = gsap.utils.toArray('.content-with-sticky-images .content-block')
	contentBlock.forEach((item, index) => {
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				scrub: false,
				start:"0 50%",
				toggleActions:"restart none none reset",
				end: "bottom 50%",
				markers: false,
				onUpdate: self => {
    				var index = $(item).attr('data-index');
    				$('.image-container').removeClass('active');

    				$('.image-container[data-index=' + index + ']').addClass('active');
  				}
			}
		});
	});

	let animate = gsap.utils.toArray('.animate')
	animate.forEach((item, index) => {
		let tl = gsap.timeline({
		scrollTrigger: {
		trigger: item,
		once: true,
		start:"0 90%",
		toggleActions:"restart none none reset",
		end: "500",
		markers: false,
		toggleClass: 'animateelement'
		}
		});
	});

/* ====================== MASTHEAD TYPING ======================  */
	if($('h1').length) {
		let instance = new TypeIt("h1", {
			lifeLike: true,
			cusorSpeed: 400,
			startDelay: 1500,
			beforeString: () => {
	    		$('h1').addClass('typing-started');
	    	},
			afterComplete: () => {
				$('h1').addClass('completed');

				setTimeout(
				function() {
					$('.ti-cursor').addClass('fadeout');
				}, 2000);
			}
		}).go();
	}

	function fnBrowserDetect(){
		let userAgent = navigator.userAgent;
		let browserName;

		if(userAgent.match(/chrome|chromium|crios/i)){
		 browserName = "chrome";
		}else if(userAgent.match(/firefox|fxios/i)){
		 browserName = "firefox";
		}  else if(userAgent.match(/safari/i)){
		 browserName = "safari";
		}else if(userAgent.match(/opr//i)){
		 browserName = "opera";
		} else if(userAgent.match(/edg/i)){
		 browserName = "edge";
		}else{
		 browserName="No browser detection";
		}

		$('body').addClass(browserName +'-browser');
	}

	  fnBrowserDetect();
});
